<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label" />
            <div class="dx-field-value">
                <dx-button text="Копирование адреса" @click="popupVisible = true" />
            </div>
        </div>
        <dx-popup
            :show-title="true"
            title="Адрес в ЕГРЮЛ"
            :drag-enabled="false"
            :hide-on-outside-click="true"
            :showCloseButton="true"
        >
            Адрес
        </dx-popup>
    </div>
</template>

<script setup>
import { DxButton, DxPopup } from 'devextreme-vue';

</script>
